document.addEventListener('turbolinks:load', event => {
    if (typeof gtag === 'function') {
        gtag('config', 'UA-53059619-6', {
            'page_location': event.data.url,
            'anonymize_ip': true
        });
    }
});